import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router";
import { getDecedentName } from "../registrationUtils";
export default function Intro({ deceased, decedent }) {
    const decedentName = getDecedentName(decedent);
    return (<div className="vr vr_x5">
			<h1 className="sr-only">Identity Validation</h1>
			<div className="text">
				{deceased && (<Fragment>
						<FormattedMessage tagName="p" id="accountValidation.intro1" defaultMessage="We are sorry for your loss."/>
						<FormattedMessage tagName="p" id="accountValidation.intro2" defaultMessage={"We are seeking to identify and locate the person who has the "
        + "authority to act on behalf of the estate of {decedentName}."} values={{ decedentName }}/>
						<FormattedMessage tagName="p" id="accountValidation.intro3" defaultMessage={"If you are not the individual handling the Estate but you know "
        + "who is, please {contactLink}."} values={{
        contactLink: (<Link className="link" to="/public/refer">
										<FormattedMessage id="accountValidation.intro3.contactLink" defaultMessage="contact us"/>
									</Link>)
    }}/>
					</Fragment>)}
				{!deceased && (<FormattedMessage tagName="p" id="accountValidation.live.intro" defaultMessage="Welcome. If you feel you have been reached in error, please {contactLink}" values={{
        contactLink: (<Link className="link" to="/public/contact">
									<FormattedMessage id="accountValidation.live.intro.contactLink" defaultMessage="contact us"/>
								</Link>)
    }}/>)}
			</div>
		</div>);
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/Registration/Intro/Intro.tsx